module.exports = __webpack_public_path__ + "static/media/Bagels.392626d1.mp3";